/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function($){
    $(function(){  // document.ready


      // Cancel Option
      $('.coming-soon').click( function(e) {
        e.preventDefault();
      });

      // Scrolling menu shift
      $(document).scroll(function() {
         if($(window).scrollTop() === 0) {
           $(".nav-bar").removeClass('scrolled');
         } else {
           $(".nav-bar").addClass('scrolled');
         }
      });

      // Searchbox toggle
        const searchbox = $('#searchDropdown');
        const backdrop = $('.modal-backdrop');
        // Search functionality
        $('.search-show').click( function() {
          searchbox.addClass('active');
          backdrop.addClass('show');

        });
        $('.close-search').click( function() {
          searchbox.removeClass('active');
          backdrop.removeClass('show');
        });

        $(document).click(function(e) {
          const search = $('#searchDropdown');
          if (e.target.id == '#searchDropdown' || $(e.target).parents('#searchDropdown').length || $(e.target).parents('.nav-bar').length) {
            // Continue
          } else {
            if($(search).is(':visible')) {
              searchbox.removeClass('active');
              backdrop.removeClass('show');
            }
          }
        });

        // Scrolling text setup
        if ($('#marquee').length) {
          $(function() {
              var marqueeInner = $("#marquee .inner-marquee");
              for (var i = 0; i < 5; i++) {
                marqueeInner.clone().insertAfter(marqueeInner);
              }
          });
        }

        // Quickview
        $('.modal__close').click( function() {
          $('.modal').attr('aria-hidden', true);
          $('html').removeClass('is-locked');
        })

        // Filter Toggle
        $('.pb-filter-btn').click( function() {
          $('#pbFilters').toggleClass('d-none');
          $('#pbProducts').toggleClass('col-lg-9');
        })

        // Hiring Modal
        $('.show-hiring').click( function() {
          $('#hiringForm').fadeIn();
          $('.modal-backdrop').fadeIn();
          $(body).addClass('modal-open');
        });
        $('#hiringHide, .modal-backdrop').click( function() {
          $('#hiringForm').fadeOut();
          $('.modal-backdrop').fadeOut();
          $(body).removeClass('modal-open');
        });


        // Testimonial Slider
        if ($('#testimonialSlider').length) {

          //var scrollerWrapper = document.getElementById("testimonialSlider");
          //$('#testimonialSlider').scroll( function() {
            //scrollPercent =
              //(scrollerWrapper.scrollLeft /
                //(scrollerWrapper.scrollWidth - scrollerWrapper.clientWidth)) *
              //100;
            //$("#progressBar").css("width", scrollPercent + "%");
          //})


          const scroller = document.getElementById("testimonialSlider");
          //const scrollerWrapper = document.getElementById('testimonialSlider').getElementsByClassName('inner-container-sm');
          const scrollerWrapper = $('#testimonialSlider .inner-container-sm');
          const clientWidth = scrollerWrapper[0].clientWidth;
          const scrollWidth = $(scroller).width();


          // Set base progress because can't 100 percent scroll
          const base = 48.85;
          $("#progressBar").css("width", base + "%");

          $('#testimonialSlider .inner-container-sm').scroll( function() {
            let scrollPercent = (((scrollerWrapper.scrollLeft() / (scrollWidth)) * 100) + base);
            console.log(scrollPercent);
            $("#progressBar").css("width", scrollPercent + "%");
          })

          const width = $(scrollerWrapper).innerWidth();
          const count = $('.testimonial-container .testimonial').length;
          var shift = $('.testimonial').first().outerWidth(true);

          $('.left-shift').click(function(){
              $(scrollerWrapper).animate({
                  scrollLeft: $(scrollerWrapper).scrollLeft() - shift + 'px'
              }, 250);
          });
          $('.right-shift').click(function(){
              $(scrollerWrapper).animate({
                  scrollLeft: $(scrollerWrapper).scrollLeft() + shift + 'px'
              }, 250);
          });

        }
    });

  $('.colletion-faqs-section .faq-que').click(function(){
        $(this).toggleClass('active');
        $(this).siblings('.faq-ans').slideToggle('300');
    });

  $(".read-more-btn").click(function() {
       $("#truncated").css("display", "none");
        $(".fullDescription").css("display", "block");
        if ($(this).text() === "Read More") {
            $(this).text("Read Less");
        } else {
            $(this).text("Read More");
        }
    });

      $(".read-more-btn").click(function() {
        if ($(this).text() === "Read More") {
            $(this).text("Read More");
         $("#truncated").css("display", "block");
        $(".fullDescription").css("display", "none");
        } 
    });

    //Functions, Plugins, Etc. here

})(jQuery);

document.addEventListener("DOMContentLoaded", function () {
  const textArea = document.querySelector('textarea[name="note"]');
  const saveButton = document.querySelector('.form__submit[data-action="save-note"]');

  let previousValue = textArea.value;

  // Function to update button text
  function updateButtonText() {
    if (textArea.value.trim() !== previousValue) {
      saveButton.textContent = "Save";
    }
  }

  // Event listener for text area input
  textArea.addEventListener("input", updateButtonText);

  // Event listener for save button click
  saveButton.addEventListener("click", function () {
    if (textArea.value.trim() !== "") {
      saveButton.textContent = "Saved";
      previousValue = textArea.value.trim();
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const textArea = document.querySelector('textarea[name="attributes[Special Instructions]"]');
  const saveButton = document.querySelector('.form__submit[data-action="save-special"]');

  let previousValue = textArea.value;

  // Function to update button text
  function updateButtonText() {
    if (textArea.value.trim() !== previousValue) {
      saveButton.textContent = "Save Instructions";
    }
  }

  // Event listener for text area input
  textArea.addEventListener("input", updateButtonText);

  // Event listener for save button click
  saveButton.addEventListener("click", function () {
    if (textArea.value.trim() !== "") {
      saveButton.textContent = "Saved";
      previousValue = textArea.value.trim();
    }
  });
});
